import React, { Component } from 'react';
import Configs from 'Configuration';
import FhtFetchUrl from 'Utils/FhtFetchUrl.jsx';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import {
  Box,
  Button,
  Grid,
  Paper,
  Snackbar,
  TextField,
  Typography,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  Collapse,
  IconButton,
  Card,
  Accordion, AccordionSummary, AccordionDetails,
  TextareaAutosize,
  InputBase
} from '@material-ui/core';

import SnackbarContentWrapper from 'components/SnackbarContentWrapper';

class WebProjectSmsContent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      smsTemplateText: "",
      smsSampleMessageText: "",
      selectedTemplate: "Default Template",
      templates: [],
      originalTemplateText: "",
      smsTemplateName: "",
      showConfirmationDialog: false,
      snackbarOpen: false,
      snackbarMessage: "",
      snackbarVariant: Configs.snackbarVariants.info,
      assignedTemplateName: "",
      assignedTemplateNamePrivacy: "",
      showHelpDialog: false,
      smsBodyExpanded: true,
      smsPreviewExpanded: true,
      editSmsExpanded: true,
      assignedTemplateExpanded: true,
    };
  }
  toggleHelpDialog = (open) => {
    this.setState({ showHelpDialog: open });
  };
  getFormattedDate() {
    const date = new Date();
    date.setDate(date.getDate() + 10);

    const day = date.getDate();
    const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    const month = monthNames[date.getMonth()];
    const year = date.getFullYear();

    const suffix = (day % 10 === 1 && day !== 11) ? "st" :
      (day % 10 === 2 && day !== 12) ? "nd" :
        (day % 10 === 3 && day !== 13) ? "rd" : "th";

    return `${day}${suffix} ${month} ${year}`;
  }
  updateSampleMessage = (text) => {
    const formattedMessage = text
      .replace(/\[NAME\]/gi, "John")
      .replace(/\[APPOINTMENT DATE\]/gi, this.getFormattedDate())
      .replace(/\[LINK TO SURVEY\]/gi, "https://redcap.unimelb.edu.au/surveys/?s=xxxxxxxxxxxxxxxx");
    this.setState({ smsSampleMessageText: formattedMessage });
  };

  handleTemplateChange = (event) => {
    const selectedTemplateName = event.target.value;
    const selectedTemplate = this.state.templates.find(template => template.smsTemplateName === selectedTemplateName);

    const newTemplateText = selectedTemplate ? selectedTemplate.smsTemplateContent : "";

    this.setState({
      selectedTemplate: selectedTemplateName,
      smsTemplateText: newTemplateText,
      originalTemplateText: newTemplateText,
    }, () => {
      this.updateSampleMessage(newTemplateText);
    });
  };

  componentDidMount() {
    this.loadSmsTemplate();
    this.loadAssignedTemplateName();
  }

  handleTextChange = (event) => {
    const newText = event.target.value;
    this.setState({ smsTemplateText: newText });
    this.updateSampleMessage(newText);
  };
  toggleEditSms = () => {
    this.setState(prevState => ({ editSmsExpanded: !prevState.editSmsExpanded }));
  };
  toggleAssignTemplate = () => {
    this.setState(prevState => ({ assignedTemplateExpanded: !prevState.assignedTemplateExpanded }));
  };

  loadAssignedTemplateName() {
    const apiBaseSms = FhtFetchUrl(`${Configs.getAssignedSmsTemplate}?smsSettingsKey=AssignedSmsTemplateWebProject`);
    apiBaseSms.get()
      .then(response => {

        console.log("API Response:", response.assignedName);
        if (response && response.assignedName !== undefined) {
          this.setState({ assignedTemplateName: response.assignedName });
        } else {
          console.error("Unexpected API response:", response);
        }
      })
      .catch(error => {
        console.error("Error fetching assigned template name:", error);
        this.showSnackbar("Could not get assigned SMS template name for survey SMS", "error");
      });

    const apiPrivacySms = FhtFetchUrl(`${Configs.getAssignedSmsTemplate}?smsSettingsKey=AssignedSmsTemplateWebProjectPrivacy`);
    apiPrivacySms.get()
      .then(response => {

        console.log("API Response:", response.assignedName);
        if (response && response.assignedName !== undefined) {
          this.setState({ assignedTemplateNamePrivacy: response.assignedName });
        } else {
          console.error("Unexpected API response:", response);
        }
      })
      .catch(error => {
        console.error("Error fetching assigned template name:", error);
        this.showSnackbar("Could not get assigned SMS template name for privacy SMS", "error");
      });
  }
  loadSmsTemplate() {
    const api = FhtFetchUrl(Configs.getSmsTemplate);
    api.get().then(response => {
      if (response.data && response.data.length > 0) {
        const defaultTemplate = response.data.find(template => template.smsTemplateName === "WEB Opt out message");
        const defaultText = defaultTemplate?.smsTemplateContent || "";

        this.setState({
          templates: response.data.filter(template => template.smsTemplateName.toUpperCase().includes("WEB")),
          selectedTemplate: defaultTemplate ? "WEB Opt out message" : "",
          smsTemplateText: defaultText,
          originalTemplateText: defaultText,
        }, () => {
          this.updateSampleMessage(defaultText);
        });
      } else {
        this.setState({ templates: [], selectedTemplate: "" }); // Handle case where no templates exist
      }
    }).catch(err => {
      this.showSnackbar("Could not load SMS template", "error");
    });
  }

  assignTemplate = (assignSmsTemplateName) => {
    const { selectedTemplate } = this.state;

    if (!selectedTemplate) {
      this.showSnackbar("Please select a template to assign.", "info");
      return;
    }

    const api = FhtFetchUrl(Configs.SaveAssignTemplateName);
    api.post({
      SmsTemplateName: selectedTemplate,
      AssignSmsTemplateName: assignSmsTemplateName,
    })
      .then(response => {
        if (response && response.message === "SUCCESS") {
          this.showSnackbar("Template assigned successfully");

          this.loadAssignedTemplateName();
        } else {
          this.showSnackbar(response.message || "An error occurred while assigning the template");
        }
      })
      .catch(() => {
        this.showSnackbar("Failed to assign template");
      });
  };

  handleCancel = () => {
    this.setState({
      smsTemplateText: this.state.originalTemplateText,
    }, () => {
      this.updateSampleMessage(this.state.originalTemplateText);
    });
  };

  showSnackbar = (message, variant = "success") => {
    this.setState({ snackbarMessage: message, snackbarVariant: variant, snackbarOpen: true });
  };

  saveTemplate = () => {
    const api = FhtFetchUrl(Configs.saveSmsTemplate);
    api.post({
      SmsTemplateName: this.state.smsTemplateName,
      SmsTemplateContent: this.state.smsTemplateText
    })
      .then(response => {
        console.log(response);
        if (response && response.message === "SUCCESS") {
          window.location.reload();
          this.showSnackbar("Template added successfully");

        } else {
          this.showSnackbar(response.message || "An error occurred", "error");
        }
      })
      .catch(() => {
        this.showSnackbar("Failed to save template", "error");
      });
  };

  handleCreateTemplate = () => {
    console.log(this.state.smsTemplateName.trim());
    if (!this.state.smsTemplateName.trim()) {
      this.setState({ showConfirmationDialog: true });
    } else {
      this.saveTemplate();
    }
  };

  handleDialogClose = (proceed) => {
    if (!proceed) {
      this.setState({ showConfirmationDialog: false, smsTemplateName: "" });
      return;
    }
    if (!this.state.smsTemplateName.trim()) {
      this.showSnackbar("Template name cannot be empty.", "info");
      return;
    }
    this.saveTemplate();
  };

  render() {
    return (
      <Box maxWidth={800} margin="auto">
        <Typography variant="h3" gutterBottom>SMS Content</Typography>
        <Grid container spacing={3}>
          <Grid item sm={12}>
            <Paper>
              <Box sx={{ padding: 12 }}>
                <Typography variant="h6" gutterBottom style={{ marginLeft: 10 }}>
                  SMS Template Configuration
                </Typography>
                <Divider></Divider>
                <Typography variant="subtitle1" style={{ marginTop: 10, marginLeft: 10, fontWeight: 'bold' }}>
                  Assigned template
                </Typography>
                <Grid container spacing={2} alignItems="center">
                  <Grid item xs={4}>

                    <Typography variant="subtitle1" style={{ marginTop: 10, marginLeft: 20 }}>
                      Selected Survey SMS Template:
                    </Typography>
                  </Grid>
                  <Grid item xs={8}>
                    <TextField
                      style={{ marginLeft: -20 }}
                      multiline
                      fullWidth
                      //width="600"
                      variant="outlined"
                      value={this.state.assignedTemplateName}
                      inputProps={{ readOnly: true }}
                      margin="normal"
                    />
                  </Grid>
                </Grid>
                <Grid container spacing={2} alignItems="center">
                  <Grid item xs={4}>

                    <Typography variant="subtitle1" style={{ marginTop: 10, marginLeft: 20 }}>
                      Selected Privacy SMS Template:
                    </Typography>
                  </Grid>
                  <Grid item xs={8}>
                    <TextField
                      style={{ marginLeft: -20 }}
                      multiline
                      fullWidth
                      //width="600"
                      variant="outlined"
                      value={this.state.assignedTemplateNamePrivacy}
                      inputProps={{ readOnly: true }}
                      margin="normal"
                    />
                  </Grid>
                </Grid>
                {/* Assign Template */}
                <Accordion
                  expanded={this.state.assignedTemplateExpanded}
                  onChange={this.toggleAssignTemplate}
                >
                  <AccordionSummary
                    style={{ backgroundColor: '#f5f5f5' }}
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                  >
                    <Typography variant="h6">Set Template</Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Grid container alignItems='center'>
                      <Grid item xs={12}>
                        <Typography variant="subtitle1" gutterBottom>
                          Choose a template and set it to send to the patients
                        </Typography>
                      </Grid>
                      <Grid item xs={12}>
                        <Box paddingBottom={1}>
                          <FormControl fullWidth>
                            <InputLabel>Select a template</InputLabel>
                            <Select value={this.state.selectedTemplate} onChange={this.handleTemplateChange}>
                              {this.state.templates.map((template, index) => (
                                <MenuItem key={index} value={template.smsTemplateName}>
                                  {template.smsTemplateName}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        </Box>
                      </Grid>
                      <Grid item xs={12}>
                        <Box display='flex' flexDirection='row'>
                          <Box paddingRight={1}>
                            <Button variant="contained" color="primary" onClick={() => this.assignTemplate("AssignedSmsTemplateWebProject")}>
                              Assign as Survey SMS Template
                            </Button>
                          </Box>
                          <Box paddingRight={1}>
                            <Button variant="contained" color="primary" onClick={() => this.assignTemplate("AssignedSmsTemplateWebProjectPrivacy")}>
                              Assign as Privacy SMS Template
                            </Button>
                          </Box>
                        </Box>
                      </Grid>
                    </Grid>
                  </AccordionDetails>
                </Accordion>


                {/* Edit SMS */}
                <Accordion
                  style={{ backgroundColor: '#f5f5f5' }}
                  expanded={this.state.editSmsExpanded}
                  onChange={this.toggleEditSms}
                >
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="edit-sms-content"
                    id="edit-sms-header"
                  >
                    <Typography variant="h6">Edit SMS</Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Grid container spacing={4} style={{ backgroundColor: 'white' }}>

                      <Box padding={2}>
                        <Typography variant="body1" gutterBottom>
                          The text for the SMS has been approved by the University of Melbourne HREC. Please do not adjust this wording without speaking with a member of the project team
                        </Typography>
                      </Box>

                      {/* SMS Body */}
                      <Grid item xs={12} sm={6}>
                        <Box sx={{ height: '450px', padding: 2, display: 'flex', flexDirection: 'column' }}>
                          <Typography gutterBottom variant="subtitle1" style={{ fontWeight: 'bold' }}>
                            SMS Body
                          </Typography>

                          <Box
                            sx={{
                              flex: 1,
                              border: '1px solid #ccc',
                              borderRadius: '4px',
                              padding: '10px',
                              backgroundColor: 'f5f5f5',
                              //overflowY: 'auto'
                            }}
                          >
                            <TextareaAutosize
                              value={this.state.smsTemplateText}
                              onChange={(event) => {
                                const newText = event.target.value;

                                // Prevent exceeding 500 characters
                                if (newText.length <= 500) {
                                  this.setState({ smsTemplateText: newText });
                                  this.updateSampleMessage(newText);
                                }
                              }}
                              minRows={8}
                              style={{
                                width: '100%',
                                height: '100%',
                                resize: 'none',
                                outline: 'none',
                                border: 'none',
                                backgroundColor: 'white',
                                padding: '10px',
                                overflowY: 'auto',
                                fontSize: '15px',
                                fontFamily: 'Arial, sans-serif',
                              }}
                            />

                          </Box>
                          <Typography variant="caption" align="right" color="textSecondary">
                            {`${this.state.smsTemplateText?.length || 0}/500 characters`}
                          </Typography>
                          <Box sx={{ display: 'flex', justifyContent: 'space-between', marginTop: 1 }}>
                            <FormControl sx={{ minWidth: '150px' }}>
                              <Select
                                displayEmpty
                                onChange={(event) => {
                                  const placeholder = event.target.value;
                                  this.setState(prevState => {
                                    const updatedText = prevState.smsTemplateText + ' ' + placeholder;
                                    return { smsTemplateText: updatedText };
                                  }, () => {
                                    // Call updateSampleMessage() to update the preview
                                    this.updateSampleMessage(this.state.smsTemplateText);
                                  });
                                }}
                                value=""
                                sx={{
                                  border: '1px solid #ccc',
                                  borderRadius: '4px',
                                  backgroundColor: 'white'
                                }}
                              >
                                <MenuItem value="" disabled>Insert placeholder</MenuItem>
                                <MenuItem value="[NAME]">Name</MenuItem>
                                <MenuItem value="[APPOINTMENT DATE]">Appointment Date</MenuItem>
                                <MenuItem value="[LINK TO SURVEY]">LINK TO SURVEY</MenuItem>
                              </Select>
                            </FormControl>
                            <Button
                              variant="contained"
                              color="primary"
                              onClick={() => {
                                this.setState({ smsTemplateText: "" });
                                this.updateSampleMessage("");
                              }}
                            >
                              Clear Message
                            </Button>
                          </Box>
                        </Box>
                      </Grid>

                      {/* SMS Preview */}
                      <Grid item xs={12} sm={6} style={{ backgroundColor: 'white' }}>
                        <Box sx={{ height: '400px', padding: 2, display: 'flex', flexDirection: 'column' }}>
                          <Typography variant="subtitle1" gutterBottom style={{ fontWeight: 'bold' }}>
                            SMS Preview
                          </Typography>

                          <Box
                            sx={{
                              flex: 1,
                              display: 'flex',
                              alignItems: 'flex-end',
                              justifyContent: 'flex-end',
                              padding: '10px',
                              backgroundColor: 'f5f5f5',
                              border: '1px solid #ccc',
                              overflowY: 'auto',
                            }}
                          >
                            <Box
                              sx={{
                                maxWidth: '80%',
                                backgroundColor: '#1a73e8',
                                color: 'white',
                                borderRadius: '20px',
                                padding: '10px 15px',
                                boxShadow: 2,
                                wordBreak: 'break-word',
                                overflowY: 'auto',
                                maxHeight: '100%',
                              }}
                            >
                              <Typography variant="body1" sx={{ color: 'white' }}>
                                {/* {this.state.smsSampleMessageText} */}
                                {this.state.smsSampleMessageText.split('\n').map((line, idx) => (<div key={idx}>{line}</div>))}
                              </Typography>
                            </Box>
                          </Box>
                          <Typography variant="caption" align="right" color="textSecondary">
                            {`${this.state.smsSampleMessageText?.length || 0}/500 characters`}
                          </Typography>
                        </Box>
                      </Grid>

                    </Grid>
                  </AccordionDetails>
                </Accordion>


              </Box>

            </Paper>
          </Grid>

          {/* Save & Cancel buttons */}
          <Grid container spacing={1} justifyContent="center">
            <Grid item>
              <Button
                variant="contained"
                color="primary"
                disabled={this.state.smsTemplateText === this.state.originalTemplateText}
                onClick={this.handleCreateTemplate}
              >
                Save
              </Button>
            </Grid>
            <Grid item>
              <Button variant="contained" color="error" onClick={this.handleCancel}>
                Cancel
              </Button>
            </Grid>
          </Grid>
        </Grid>

        {/* Dialog for template name */}
        <Dialog open={this.state.showConfirmationDialog}>
          <DialogTitle>Insert Template Name</DialogTitle>
          <DialogContent>
            <DialogContentText>Please insert the template name.</DialogContentText>
            <TextField
              autoFocus
              margin="dense"
              label="Template Name"
              fullWidth
              variant="outlined"
              value={this.state.smsTemplateName}
              onChange={(event) => this.setState({ smsTemplateName: event.target.value })}
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={() => this.handleDialogClose(false)} color="secondary">
              Cancel
            </Button>
            <Button onClick={() => this.handleDialogClose(true)} color="primary">
              Submit
            </Button>
          </DialogActions>
        </Dialog>

        {this.renderSnackbar()}
      </Box>
    );
  }

  renderSnackbar() {
    return (
      <Snackbar
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        open={this.state.snackbarOpen}
        autoHideDuration={4000}
        onClose={() => this.setState({ snackbarOpen: false })}
      >
        <SnackbarContentWrapper
          onClose={() => this.setState({ snackbarOpen: false })}
          variant={this.state.snackbarVariant}
          message={this.state.snackbarMessage}
        />
      </Snackbar>
    );
  }
}

export default WebProjectSmsContent;
